var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Dropdown } from "semantic-ui-react";
import { useUserActions } from "@iscr/xAppLib/Users/AdminUsers/UserActionsContext";
export function RestoreUserAction(_a) {
    var { content } = _a, props = __rest(_a, ["content"]);
    const { can, action } = useUserActions();
    if (!can("user:restore")) {
        return null;
    }
    return (_jsx(Dropdown.Item, Object.assign({}, props, (content ? { content } : { text: "Restore archived user", icon: { name: "smile outline", color: "green" } }), { onClick: () => action({ type: "user:restore" }) })));
}
